import LiveMathsDataConverter from '../../../helpers/export-data-converter/live-maths-data-converter';
import {
    EXPORT_RESOURCE_METHODS,
    REPORT_LEVEL_ALL_CLASSES,
    REPORT_LEVEL_SINGLE_CLASS,
    REPORT_LEVEL_GROUP,
    REPORT_LEVEL_ALL_YEARS,
    REPORT_LEVEL_YEAR_GROUP_TEACHER,
    FILE_FORMAT
} from './export-report-actions';
import activeFiltersSelectors from '../../report-filters/redux/active-filters/active-filters-selectors';

/**
 * Calculates the export parameters needed for the current live maths report
 */
export default function exportLiveMathsReport(getState, reportLevel) {
    const state = getState();
    const { liveMathsLevel, liveMathsAllClasses, liveMathsSingleClass } = state;
    const selectedDate = activeFiltersSelectors.selectDate(state);

    const resourcesMethod = EXPORT_RESOURCE_METHODS[reportLevel];
    const params = {
        reportType: 'live-maths',
        fileFormat: FILE_FORMAT.PDF
    };
    let data;

    switch (reportLevel) {
        case REPORT_LEVEL_ALL_YEARS:
        case REPORT_LEVEL_ALL_CLASSES:
        case REPORT_LEVEL_YEAR_GROUP_TEACHER: {
            data = LiveMathsDataConverter.convertAllClasses(
                liveMathsAllClasses,
                selectedDate,
                liveMathsLevel,
                activeFiltersSelectors.selectExportReportHeading(state),
                reportLevel === REPORT_LEVEL_ALL_YEARS
            );

            if (reportLevel === REPORT_LEVEL_YEAR_GROUP_TEACHER) {
                params.yearGroupId = activeFiltersSelectors.selectYearGroupIdForApi(
                    state
                );
                params.teacherId = activeFiltersSelectors.selectTeacherIdForApi(
                    state
                );
            }
            break;
        }

        case REPORT_LEVEL_SINGLE_CLASS:
        case REPORT_LEVEL_GROUP:
            data = LiveMathsDataConverter.convertSingleClass(
                liveMathsSingleClass,
                selectedDate,
                liveMathsLevel,
                reportLevel === REPORT_LEVEL_GROUP
                    ? activeFiltersSelectors.selectGroupId(state)
                    : null
            );
            params.classroomId = activeFiltersSelectors.selectClassId(state);
            break;

        default:
            return null;
    }

    return { data, resourcesMethod, params };
}



// WEBPACK FOOTER //
// ./components/sub-heading/export-report/export-live-maths-report.js